export { default, loader } from "~/components/product/BuyTogether";

export const eager = true;
export const sync = true;
